module.exports = __webpack_public_path__ + "img/light_bg.0f435907.png";